module.exports = __webpack_public_path__ + "static/img/mrtx@3x.defd5dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/my/mrtx@3x.png
// module id = smZg
// module chunks = 1